import React from 'react';
import styled, { css } from 'styled-components';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 10px;
  max-width: 500px;
  width: 100%;
  z-index: 99999999;
  ${(parentWidth < 430) && css`
    width: 80% !important;
  `};
`;

const Modal = ({ children, closeModal }) => {
  const modalRef = React.useRef();

  const handleClose = (e) => {
    if (e.target === modalRef.current) {
      closeModal();
    }
  };

  return (
    <ModalWrapper ref={modalRef} onClick={handleClose}>
      <ModalContent>
        {children}
      </ModalContent>
    </ModalWrapper>
  );
};

export default Modal;
